import React from 'react';
import './status-pill.scss';

/**
 * The colours a status can take. Every list that shows a workflow status maps
 * its name onto one of these, so a status reads the same on the Stages tab, in
 * the identity strip and in the modal header.
 *
 * `complete` is the step after `success` in a two-stage finish -- a document
 * that is Signed (success) and then Sent (complete), matching an invoice's
 * Sent -> Entered colours.
 */
export type PillTone = 'neutral' | 'warning' | 'info' | 'success' | 'complete' | 'danger';

interface StatusPillProps {
  label: string;
  tone?: PillTone;
  className?: string;
}

const StatusPill: React.FC<StatusPillProps> = ({ label, tone = 'neutral', className = '' }) => (
  <span className={`status-pill status-pill--${tone} ${className}`.trim()}>{label}</span>
);

export default StatusPill;
